// @flow
import { hideDialog, openDialog } from '../../../../../react/features/base/dialog/actions';
import { translate } from '../../../../../react/features/base/i18n/functions';
import { IconCloseLarge } from '../../../../../react/features/base/icons/svg';
import Dialog from '../../../../../react/features/base/ui/components/web/Dialog';
import React from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import ConfirmDialog from './ConfirmDialog';

type Props = {

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Dispatch<any>,
}

class RecordingsList extends React.PureComponent<{}, Props> {

    state: State = {
        listArray: []
    };

    constructor(props: Props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit() {
        this.props.dispatch(hideDialog(ConfirmDialog));
    }

    componentDidMount() {
        this.getStatus();
    }

    getStatus = () => {
        APP.WildixAPI.Recording.checkStatusQueue('record').then(({ result }) => {
            this.setState({ listArray: [] });
            if (result.recordings && result.recordings.length) {
                this.setState({
                    listArray: result.recordings
                });
            }
        });
    };

    removeRecording = (path, filename) => {
        this.props.dispatch(openDialog(ConfirmDialog, {
            filename,
            path
        }));
    };

    render() {
        const { listArray } = this.state;
        const xmppLogin = APP.conference.__getMyUserJid().split('@')[0];

        return (
            <Dialog
                cancel = {{ hidden: true }}
                ok = {{ translationKey: 'dialog.done' }}
                onSubmit = { this._onSubmit }
                titleKey='title.recordList'
                size = 'large'>
                {listArray.map((item, index) => {
                    const showRemoveButton = item.username === xmppLogin;

                    return (
                        <div className={'recording-list'} key={index}>
                            <a target={'_blank'}
                                href={`${item.path}?download`}
                                download
                                className={'recording-link'} rel="noreferrer">
                                {item.filename}
                                <span className="recording-date">
                                    {item.date}
                                </span>
                            </a>
                            <div className= { `recording-remove-wrapper ${showRemoveButton ? 'icon' : 'empty'}` }>
                                { showRemoveButton && <div className="recording-remove"
                                    onClick={this.removeRecording.bind(this, item.path, item.filename)}>
                                    <IconCloseLarge/>
                                </div> }
                            </div>
                        </div>
                    );
                })}
            </Dialog>
        );
    }
}

export default translate(connect(null, null)(RecordingsList));
